// extracted by mini-css-extract-plugin
export var box = "profileOverview-module--box--d726d";
export var description = "profileOverview-module--description--23270";
export var employeesLink = "profileOverview-module--employeesLink--9e6d7";
export var flexbox = "profileOverview-module--flexbox--30677";
export var gatsbyRespImageBackgroundImage = "profileOverview-module--gatsby-resp-image-background-image--22237";
export var gatsbyRespImageLink = "profileOverview-module--gatsby-resp-image-link--f09cf";
export var image = "profileOverview-module--image--ec76e";
export var input = "profileOverview-module--input--f0fba";
export var load8 = "profileOverview-module--load8--b0056";
export var loader = "profileOverview-module--loader--3f829";
export var profile = "profileOverview-module--profile--53155";
export var profiles = "profileOverview-module--profiles--da3b1";
export var viewwidth = "profileOverview-module--viewwidth--f3179";